import styled from "styled-components";
import { themeTypes } from "../../styled/Theme";

export const StyledScorebug = styled.div`
  font-family: MLSTifo;
  width: 60px;
  display: flex;
  justify-content: center;

  &.mls-c-scorebug--vertical {
    width: 30px;

    .mls-c-scorebug__separator {
      visibility: hidden;
    }

    .mls-c-scorebug__post,
    .mls-c-scorebug__live {
      width: 30px;
      height: 62px;
      flex-direction: column;
    }

    .goal-anim {
      flex-direction: column;
      font-size: ${(props) => props.theme.mixins.pxToRem(12)};
      font-weight: ${(props) => props.theme.figma.base.fontweight_bold};
    }
    .mls-c-scorebug__wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .mls-c-scorebug__separator {
    width: 1px;
    height: 18px;
    border-right: 1px solid
      ${(props) =>
        props.theme.type == themeTypes.light
          ? props.theme.figma.base.color_offblack_25
          : props.theme.figma.base.color_white_25};
  }

  .mls-c-scorebug__score {
    padding: 0 10px;
    font-family: ${(props) =>
      props.theme.figma.base.fontfamily_mlstifo_standard};
    font-weight: ${(props) => props.theme.figma.base.fontweight_bold};
    line-height: ${(props) => props.theme.figma.base.scale_1_75}px;
    font-size: ${(props) =>
      props.theme.mixins.pxToRem(props.theme.figma.base.scale_2)};
    width: 50%;
    text-align: center;
  }
`;

export const StyledScorebugPost = styled.div`
  width: ${(props) => props.theme.figma.base.scale_7_50}px;
  height: 28px;
  border-radius: ${(props) => props.theme.figma.base.scale_0_50}px;
  color: ${(props) =>
    props.theme.type == themeTypes.light
      ? props.theme.figma.base.color_offblack_100
      : props.theme.figma.base.color_white_100};
  background-color: ${(props) =>
    props.theme.type == themeTypes.light
      ? props.theme.figma.base.color_offblack_10
      : props.theme.figma.base.color_white_10};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledScorebugLive = styled.div`
  width: ${(props) => props.theme.figma.base.scale_7_50}px;
  height: 28px;
  border-radius: ${(props) => props.theme.figma.base.scale_0_50}px;
  color: ${(props) => props.theme.figma.base.color_white_100};
  background-color: ${(props) => props.theme.figma.base.color_offblack_100};
  display: flex;
  justify-content: center;
  align-items: center;

  .mls-c-scorebug__separator {
    border-right: 1px solid ${(props) => props.theme.figma.base.color_white_25};
  }
`;

export const StyledScorebugPre = styled.div`
  text-transform: lowercase;
  color: ${(props) =>
    props.theme.type == themeTypes.light
      ? props.theme.figma.base.color_black_65
      : props.theme.figma.base.color_white_100};
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  font-size: ${(props) =>
    props.theme.mixins.pxToRem(props.theme.figma.base.scale_1_375)};
  font-weight: ${(props) => props.theme.figma.base.fontweight_bold};
  line-height: ${(props) => props.theme.figma.base.scale_2}px;
  letter-spacing: ${(props) => props.theme.figma.common.letterspacing_expanded};
`;

export const StyledStatusLabel = styled.div`
  color: ${(props) =>
    props.theme.type == themeTypes.light
      ? props.theme.figma.base.color_black_65
      : props.theme.figma.base.color_white_100};
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  font-size: ${(props) =>
    props.theme.mixins.pxToRem(props.theme.figma.base.scale_1_375)};
  font-weight: ${(props) => props.theme.figma.base.fontweight_bold};
  line-height: ${(props) => props.theme.figma.base.scale_2}px;
  letter-spacing: ${(props) => props.theme.figma.common.letterspacing_expanded};
`;

export const StyledScoreBug = styled.div``;
